<div [ngClass]="{ 'title-report-container--summary-admin': isAdmin }" class="title-report-container" id="title-report-container">
  @if (!items) {
    <div class="report-container">
      <app-loading-indicator />
    </div>
  } @else {
    <div class="filters-container">
      <div class="flex-left">
        <sag-ui-select [label]="'summary.filter.reportingPeriod' | translate" value="all" (change)="changeReportingPeriod($event)">
          <sag-ui-option value="all">{{ "generic.filter.allYears" | translate }}</sag-ui-option>
          @for (reportingPeriod of reportingPeriods; track reportingPeriod) {
            <sag-ui-option [value]="reportingPeriod">{{ "generic.filter.currentPeriod" | translate: { value: reportingPeriod } }}</sag-ui-option>
          }
        </sag-ui-select>

        <sag-ui-select [label]="'generic.filter.sortBy' | translate" [value]="noneSortOption" (change)="sortBy($event)">
          <sag-ui-option [value]="noneSortOption">{{ "generic.filter.none" | translate }}</sag-ui-option>
          @for (sortOption of sortByOptions; track sortOption.value + sortOption.direction) {
            <sag-ui-option [value]="sortOption">
              {{ "generic.filter." + sortOption.value | translate }} {{ "generic.filter." + sortOption.direction | translate }}
            </sag-ui-option>
          }
        </sag-ui-select>
      </div>

      <div class="flex-right">
        <sag-ui-select [label]="'generic.filter.groupByWithoutDots' | translate" [value]="selectedGroupByOption" (change)="group($event)">
          @for (groupOption of groupByOptions; track groupOption) {
            <sag-ui-option [value]="groupOption">{{ "generic.filter." + groupOption | translate }}</sag-ui-option>
          }
        </sag-ui-select>

        @if (isAdmin) {
          <sag-ui-button class="secondary" [square]="true" [icon]="'plus-large'" (click)="uploadFile()" />
        }
      </div>
    </div>
    <mat-tab-group [animationDuration]="0" [ngClass]="{ 'header-invisible': !items.length }" class="top-tab-group">
      @if (items.length) {
        @for (tab of getKeys(groupedItems); track tab) {
          <mat-tab [label]="getTabTranslation(tab)">
            <div class="report-container">
              @for (summaryReport of paginator.items; track summaryReport) {
                <app-summary-report-tile (delete)="delete.emit(summaryReport)" [item]="summaryReport" />
              }
            </div>
            <div class="paginator-container">
              <app-paginator
                #paginator
                (changed)="changeDetection.detectChanges()"
                [data]="groupedItems[tab] || []"
                [pageSizeOptions]="pageSizes"
                [pageSize]="pageSize" />
            </div>
          </mat-tab>
        }
      } @else {
        <mat-tab>
          <h3>{{ "summary-report.no-data" | translate }}</h3>
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>
